<template>
  <section id="features" class="section feature-preview-section" v-reveal>
    <div class="section-heading section-heading--center">
      <p class="section-kicker">{{ preview.kicker }}</p>
      <h2>{{ preview.title }}</h2>
    </div>

    <div class="feature-preview-grid">
      <article
        v-for="(item, index) in preview.items"
        :key="item.title"
        class="feature-preview-card"
        :style="{ '--delay': `${index * 90}ms` }"
      >
        <span>
          <AppIcon :name="item.icon" />
        </span>
        <h3>{{ item.title }}</h3>
        <p>{{ item.copy }}</p>
      </article>
    </div>

    <a class="feature-preview-action" :href="preview.actionHref">
      <span>{{ preview.action }}</span>
      <AppIcon name="arrow-right" />
    </a>

    <div class="feature-setup">
      <div class="section-heading section-heading--center">
        <p class="section-kicker">{{ preview.setup.kicker }}</p>
        <h2>{{ preview.setup.title }}</h2>
        <p>{{ preview.setup.copy }}</p>
      </div>

      <div class="feature-setup-flow">
        <article
          v-for="(step, index) in preview.setup.steps"
          :key="step.title"
          class="feature-setup-card"
          :class="{ 'feature-setup-card--large': index === 0 }"
        >
          <div class="feature-setup-card__image">
            <img :src="setupImages[step.image]" :alt="step.title" />
          </div>
          <span class="feature-setup-card__number">0{{ index + 1 }}</span>
          <h3>{{ step.title }}</h3>
          <p>{{ step.copy }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import AppIcon from './AppIcon.vue'
import configureImage from '../assets/setup-configure.png'
import inviteImage from '../assets/setup-invite.png'
import loginImage from '../assets/setup-login.png'

export default {
  name: 'FeaturePreviewSection',
  components: {
    AppIcon
  },
  props: {
    preview: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      setupImages: {
        configure: configureImage,
        invite: inviteImage,
        login: loginImage
      }
    }
  }
}
</script>
